import { createStandardAction, getType } from 'typesafe-actions'
import { combineReducers, AnyAction } from 'redux'

import { IState } from './types'
import { installationsReducer, initialInstallationsState } from './installations/reducers'
import { initialPlansState, plansReducer } from './plans/reducers'
import { initialHospitalsState, hospitalsReducer } from './hospitals/reducers'
import { usersReducer, initialUsersState } from './users/reducers'
import { initialSSORealmsState, ssoRealmsReducer } from './ssoRealms/reducers'
import { initialDrugsState, drugsReducer } from './drugs/reducers'
import { initialSubscriptionsState, subscriptionsReducer } from './subscriptions/reducers'

const resetStore = createStandardAction('@@root/RESET_STORE')()

const initialState: IState = {
  installations: initialInstallationsState,
  hospitals: initialHospitalsState,
  subscriptions: initialSubscriptionsState,
  plans: initialPlansState,
  ssoRealms: initialSSORealmsState,
  users: initialUsersState,
  drugs: initialDrugsState
}

const appReducer = combineReducers({
  installations: installationsReducer,
  hospitals: hospitalsReducer,
  subscriptions: subscriptionsReducer,
  plans: plansReducer,
  ssoRealms: ssoRealmsReducer,
  users: usersReducer,
  drugs: drugsReducer
})

const rootReducer = (state: IState = initialState, action: AnyAction): IState => {
  switch (action.type) {
    case getType(resetStore): {
      return {
        ...initialState
      }
    }
  }

  return appReducer(state, action)
}

export { rootReducer, initialState, resetStore }
